import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../../features/external-api/redux/actions';
import ExternalApiHeaderNav from '../ExternalApiHeaderNav';
import CustomLoader from '../../common/CustomLoader';
import ParentDocCard from '../../common/ParentDocCard';
import ParentContentCard from '../../common/ParentContentCard';
import { CHAT_GPT } from 'drapcode-constant';
import { checkToShowSaveBtn } from '../../plugin/utils';
import { parseExtractPluginCode } from '../../../common/utils/plugin_utils';
import { ChatGptList } from './ChatGptList';
import { checkChatGPTPermission } from '../../../common/utils/permissions';
import PermissionDenied from '../../../common/PermissionDenied';
export class ChatGpt extends Component {
  static propTypes = {
    externalapi: PropTypes.object.isRequired,
    home: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  state = { page: 0, searchTerm: '', limit: 25, headers: [] };
  componentDidMount = async () => {
    const { match, actions, home } = this.props;
    const { projectId, version } = match.params;
    const { iPlugins } = home;
    await actions.loadCollections({ projectId, version });
    await actions.loadExternalApis({
      projectId,
      version,
      page: this.state.page,
      externalApiType: CHAT_GPT,
      limit: this.state.limit,
    });
    await actions.loadExternalDatabase({ projectId, version });
    const extenalData = this.props.externalapi.externalDatabase;
    if (extenalData) {
      const dataTypes = [...new Set(extenalData.map((item) => item.type))];
      this.setState({ headers: dataTypes });
    }
  };

  shouldComponentUpdate(nextProps, nextState, nextContext) {
    const { home: nextHome } = nextProps;
    const { home } = this.props;
    const { iPlugins: nextIPlugins } = nextHome;
    if (!nextIPlugins || nextIPlugins.length === 0) {
      return true;
    }
    const { iPlugins } = home;
    if (!checkToShowSaveBtn(nextIPlugins, iPlugins)) {
      const headers = parseExtractPluginCode(nextIPlugins, 'EXTERNALAPI');
      this.setState({ headers });
    }
    return true;
  }

  updateSearchTerm = (value) => {
    this.setState({ searchTerm: value });
  };

  onPageChange = (val) => {
    const { projectId, version } = this.props.match.params;
    const { limit, searchTerm } = this.state;

    this.props.actions.loadExternalApis({
      projectId,
      page: val.selected,
      limit,
      version,
      externalApiType: CHAT_GPT,
      searchTerm,
    });

    this.setState({ page: val.selected });
  };

  handleSearch = () => {
    const { projectId, version } = this.props.match.params;
    const { page, limit, searchTerm } = this.state;
    this.props.actions.loadExternalApis({
      projectId,
      version,
      page,
      limit,
      searchTerm,
      externalApiType: CHAT_GPT,
    });
  };

  render() {
    const isAllowed = checkChatGPTPermission();
    if (!isAllowed) {
      return <PermissionDenied message="Chat GPT APIs" />;
    }
    const { match, externalapi } = this.props;
    const { projectId, version } = match.params;
    const { loadExternalApisPending } = externalapi;
    const { headers, page, limit } = this.state;
    return (
      <div className="main">
        <div className="section">
          <div className="container externalapi">
            <ExternalApiHeaderNav
              version={version}
              activeTab={CHAT_GPT}
              projectId={projectId}
              headers={headers}
            />
            <div className="row mx-auto">
              <ParentContentCard
                // bgColor="drapcode-violet"
                icon={CHAT_GPT}
                title={'ChatGPT'}
                headerLink={`/2.0/externalapi/${version}/v/${projectId}/chatGpt/create`}
                headerTitle="Create ChatGPT API"
                headerText="Create"
                isSearch={true}
                updateSearchTerm={this.updateSearchTerm}
                handleSearch={this.handleSearch}
              >
                {loadExternalApisPending ? (
                  <div className="text-center">
                    <CustomLoader loading={loadExternalApisPending} size="20px" color="#303453" />
                  </div>
                ) : (
                  <ChatGptList
                    projectId={projectId}
                    version={version}
                    actions={actions}
                    externalapi={externalapi}
                    page={page}
                    limit={limit}
                    onPageChange={this.onPageChange}
                  />
                )}
              </ParentContentCard>
              <ParentDocCard>
                <h5>
                  <b>About ChatGPT API</b>
                </h5>
                <p>
                  DrapCode supports ChatGPT to send or process data using ChatGPT API integration.
                </p>
                <br />
              </ParentDocCard>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    externalapi: state.externalapi,
    home: state.home,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ChatGpt);
